import { render, staticRenderFns } from "./CreateNewModal.vue?vue&type=template&id=2b93f2d4&scoped=true&"
import script from "./CreateNewModal.vue?vue&type=script&lang=js&"
export * from "./CreateNewModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewModal.vue?vue&type=style&index=0&id=2b93f2d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b93f2d4",
  null
  
)

export default component.exports